import { render, staticRenderFns } from "./modalVisualizarTomador.vue?vue&type=template&id=4ef5a350"
import script from "./modalVisualizarTomador.vue?vue&type=script&lang=js"
export * from "./modalVisualizarTomador.vue?vue&type=script&lang=js"
import style0 from "./modalVisualizarTomador.vue?vue&type=style&index=0&id=4ef5a350&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports